import { render, staticRenderFns } from "./ClientAutocomplete.vue?vue&type=template&id=3557be0c&scoped=true&"
import script from "./ClientAutocomplete.vue?vue&type=script&lang=js&"
export * from "./ClientAutocomplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3557be0c",
  null
  
)

export default component.exports